import "@hotwired/turbo-rails"
import "./controllers"
import $ from "jquery";
import Quill from "quill";

// Initialize on pages with a #editor div
document.addEventListener("turbo:load", () => {
  const editorDiv = document.getElementById("editor");
  const hiddenInput = document.getElementById("hidden_body");

  const toolbarOptions = [
    ['bold', 'italic'],
    ['blockquote'],
    ['link'],
    [{ 'header': 1 }, { 'header': 2 }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'align': [] }],
    ['clean']
  ];

  if (editorDiv && hiddenInput) {
    const quill = new Quill(editorDiv, {
      theme: "snow",
      modules: {
        toolbar: toolbarOptions
      }
    });

    // Load initial content
    quill.root.innerHTML = hiddenInput.value;

    // Sync changes to hidden input
    quill.on("text-change", () => {
      hiddenInput.value = quill.root.innerHTML;
    });
  }
});

$(document).on('ready turbo:load', function() {

  // Alert Dismiss
  $('.alert').on('click', 'button', function(e){
    $(this).parent().hide();
  });

  // Dashboard Mobile Nav
  $('.dashboard_nav_toggle').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('dashboard_nav_toggle--active');
    $('#dashboard_nav').toggleClass('show');
  });

  // JS Sorting Tables

  /*
   * @param {HTMLTableElement} table The table to sort
   * @param {number} column The index of the column to sort
   * @param {boolean} asc Determines if the sorting will be in ascending
  */

   function sortTableByColumn(table, column, asc = true) {
    const dirModifier = asc ? 1 : -1;
    const tBody = table.tBodies[0];
    const rows = Array.from(tBody.querySelectorAll("tr"));

    // Sort each row
    const sortedRows = rows.sort((a, b) => {
        let aColText = a.querySelector(`td:nth-child(${ column + 1 })`).textContent.trim();
        let bColText = b.querySelector(`td:nth-child(${ column + 1 })`).textContent.trim();

        if (!isNaN(parseFloat(aColText)) && !isNaN(parseFloat(bColText))) {
          aColText = parseFloat(aColText)
          bColText = parseFloat(bColText)
        }

        return aColText > bColText ? (1 * dirModifier) : (-1 * dirModifier);
    });

    // Remove all existing TRs from the table
    while (tBody.firstChild) {
        tBody.removeChild(tBody.firstChild);
    }

    // Re-add the newly sorted rows
    tBody.append(...sortedRows);

    // Remember how the column is currently sorted
    table.querySelectorAll("th").forEach(th => th.classList.remove("sortable_table__asc", "sortable_table__desc"));
    table.querySelector(`th:nth-child(${ column + 1})`).classList.toggle("sortable_table__asc", asc);
    table.querySelector(`th:nth-child(${ column + 1})`).classList.toggle("sortable_table__desc", !asc);
  }

  document.querySelectorAll(".js_sortable_table th").forEach(headerCell => {
    headerCell.addEventListener("click", () => {
        const tableElement = headerCell.parentElement.parentElement.parentElement;
        const headerIndex = Array.prototype.indexOf.call(headerCell.parentElement.children, headerCell);
        const currentIsAscending = headerCell.classList.contains("sortable_table__asc");

        sortTableByColumn(tableElement, headerIndex, !currentIsAscending);
    });
  });

  // Responsive Tables

  $( ".responsive_table" ).scroll(function() {
    if($('.responsive_table').scrollLeft() > 1) {
      $(this).addClass('responsive_table--scrolled');
    } else {
      $(this).removeClass('responsive_table--scrolled');
    }
  });

  // Table filters

  $('.filter_female').hide();
  $('.table_filter__option--male').addClass('table_filter__option--active');

  $('.table_filter__option').on('click', function(){
    if ($(this).hasClass('table_filter__option--male')) {
      $('.filter_female').hide();
      $('.filter_male').show();
      $(this).siblings().removeClass('table_filter__option--active');
      $(this).addClass('table_filter__option--active');
    } else {
      $('.filter_female').show();
      $('.filter_male').hide();
      $(this).siblings().removeClass('table_filter__option--active');
      $(this).addClass('table_filter__option--active');
    }

  });

});